import React, { FunctionComponent, memo } from "react";
import { isEqual } from "lodash";

import BaseCard, { BaseCardProps } from "./BaseCard";
import IframeChart from "components/iframe-chart";
import { SiteConfig_siteConfig_dashboardConf_components_chartData } from "graphql/generated";

interface IProps extends BaseCardProps {
  chart: SiteConfig_siteConfig_dashboardConf_components_chartData | undefined;
}


const AnalyticsCard: FunctionComponent<IProps> = memo(function Analytics({ chart, ...rest }) {
  return (
    <BaseCard {...rest} isWrappedInside={false}>
      <IframeChart title="Analytics" chart={chart} hasBorder={false} />
    </BaseCard>
  );
}, isEqual);

export default AnalyticsCard;
